import { useCallback } from "react";

import { useSelector } from "common/utilities/react-redux";
import { getAllTermsById } from "domains/language/selectors";
import type { Term } from "domains/language/types";

export const useTranslate = () => {
  const termsById = useSelector(getAllTermsById);
  return useCallback((value: Term) => termsById[value] ?? "", [termsById]);
};
